import { z } from 'zod';
import { bankAccountSchema } from './bank-transfer';
import { businessNumberSchema } from './business-profile';

const timestampSchema = z.iso.datetime();
const text = (max: number) => z.string().trim().min(1).max(max);

/** 공급자(우리 회사) 정보 — 계좌이체 안내와 세금계산서 공급자란에 쓴다. 저장할 때는 전부 필수. */
export const supplierSettingsFieldsSchema = z.strictObject({
  businessNumber: businessNumberSchema,
  companyName: text(50),
  representativeName: text(50),
  address: text(200),
  businessType: text(50),
  businessItem: text(50),
  contactName: text(50),
  contactEmail: z.email().max(254),
  contactPhone: z.string().regex(/^[0-9-]{9,20}$/, '연락처는 숫자와 하이픈만 입력해 주세요.'),
  bank: bankAccountSchema,
});
export type SupplierSettingsFields = z.infer<typeof supplierSettingsFieldsSchema>;

export const updateSupplierSettingsInputSchema = supplierSettingsFieldsSchema;
export type UpdateSupplierSettingsInput = z.infer<typeof updateSupplierSettingsInputSchema>;

/** 읽기 — 아직 저장하지 않았거나 일부만 있을 수 있어 칸마다 null 을 허용하고, 완성 여부(`complete`)를 함께 준다. */
export const adminSupplierSettingsSchema = z.strictObject({
  businessNumber: businessNumberSchema.nullable(),
  companyName: z.string().nullable(),
  representativeName: z.string().nullable(),
  address: z.string().nullable(),
  businessType: z.string().nullable(),
  businessItem: z.string().nullable(),
  contactName: z.string().nullable(),
  contactEmail: z.string().nullable(),
  contactPhone: z.string().nullable(),
  bank: bankAccountSchema.nullable(),
  updatedAt: timestampSchema.nullable(),
  updatedByName: z.string().nullable(),
  complete: z.boolean(),
});
export type AdminSupplierSettings = z.infer<typeof adminSupplierSettingsSchema>;
